/**
 * Asynchronously loads the component for ProfilePage
 */

import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "ProfilePage" */ './index'), {
  fallback: <LoadingPage delay={1} />
})
